import { Backdrop, CircularProgress } from "@mui/material";
import React from "react";

interface ILoadingProps {
    loading: boolean;
    noBackdrop?: boolean;
    noSpinner?: boolean;
}

const Loading: React.FC<ILoadingProps> = (props) => {
    return (
        <>
            {props.noBackdrop === true ? <Backdrop style={{ zIndex: 5000, backgroundColor: "transparent" }} open={props.loading}>
                {props.noSpinner === true ? null : <CircularProgress color="inherit" />}
            </Backdrop> : <Backdrop style={{ zIndex: 5000, color: 'green' }} open={props.loading}>
                {props.noSpinner === true ? null : <CircularProgress color="inherit" />}
            </Backdrop>}
        </>

    );
};

export default Loading;
